import axiosClient from "./axiosClient";

const medicalSuppliesService = {
  getListSuppliesName: async (params) => {
    const url = "store/VTYT/list-VatTuYTe";
    const response = await axiosClient.get(url, {
      params: {
        limit: 9999,
        ...params,
      },
    });
    return response.data.data;
  },
  getListVTInDuTruPT: async (start, end) => {
    const url = `store/receipt/phieu-du-tru-vtyt?start=${start}&end=${end}`;

    const response = await axiosClient.get(url);
    return response.data;
  },

  getListSuppliesGroup: async () => {
    const url = "store/dmNhomVTYT/list-DMNhomVatTuYTe";
    const response = await axiosClient.get(url, {
      params: {
        limit: 1000,
      },
    });
    return response.data.data;
  },
  postSuppliesGroup: async (params) => {
    const url = "store/dmNhomVTYT/create";
    const response = await axiosClient.post(url, params);
    return response.data;
  },
  putSuppliesGroup: async (params) => {
    const url = "store/dmNhomVTYT/update";
    const response = await axiosClient.put(url, params);
    return response.data;
  },
  deleteSuppliesGroup: async (id) => {
    const url = "store/dmNhomVTYT/delete";
    const response = await axiosClient.delete(url, { params: { id } });
    return response.data;
  },
  getListSuppliesStore: async (params) => {
    const url = "store/store/groups-vat-tu";
    const response = await axiosClient.get(url, {
      params: {
        limit: 2000,
        ...params,
      },
    });
    return response.data;
  },
  postSuppliesStore: async (params) => {
    const url = "store/store/groups-vat-tu";
    const response = await axiosClient.post(url, params);
    return response.data;
  },
  putSuppliesStore: async (params) => {
    const url = "store/store/groups-vat-tu";
    const response = await axiosClient.put(url, params);
    return response.data;
  },
  deleteSuppliesStore: async (id) => {
    const url = "store/store/delete";
    const response = await axiosClient.delete(url, { params: { id } });
    return response.data;
  },
  getListSupplier: async () => {
    const url = "store/supplier/groups-vat-tu";
    const response = await axiosClient.get(url, {
      params: {
        limit: 1000,
      },
    });
    return response.data.data;
  },
  getLichSuXuatNhapByIdLo: async soLo => {
    const url = "/store/VTYT-store/by-id";
    const params = { id: soLo, isXemLichSu: true };
    const res = await axiosClient.get(url, { params: params });
    return res.data;
  },
  postSupplier: async (params) => {
    const url = "store/supplier/groups-vat-tu";
    const response = await axiosClient.post(url, params);
    return response.data;
  },
  putSupplier: async (params) => {
    const url = "store/supplier/groups-vat-tu";
    const response = await axiosClient.put(url, params);
    return response.data;
  },
  deleteSupplier: async (id) => {
    const url = "store/supplier/delete";
    const response = await axiosClient.delete(url, { params: { id } });
    return response.data;
  },
  getListManufacturer: async () => {
    const url = "store/manufacturer/groups-vat-tu";
    const response = await axiosClient.get(url, {
      params: {
        limit: 1000,
      },
    });
    return response.data.data;
  },
  postManufacturer: async (params) => {
    const url = "store/manufacturer/groups-vat-tu";
    const response = await axiosClient.post(url, params);
    return response.data;
  },
  putManufacturer: async (params) => {
    const url = "store/manufacturer/groups-vat-tu";
    const response = await axiosClient.put(url, params);
    return response.data;
  },
  deleteManufacturer: async (id) => {
    const url = "store/manufacturer/delete";
    const response = await axiosClient.delete(url, { params: { id } });
    return response.data;
  },
  getListManufacturedCountry: async (params) => {
    const url = "store/manufactured-country/list-manufactured-country";
    const response = await axiosClient.get(url, {
      params: {
        limit: 1000,
        ...params,
      },
    });
    return response.data.data;
  },
  searchMedicalSupplies: async (params) => {
    const url = "store/VTYT-store/searchKey";
    const response = await axiosClient.get(url, { params });
    return response.data;
  },
  searchReceiptSupplies: async (params) => {
    const url = "store/receipt/search-key/groups-VTYT";
    const response = await axiosClient.get(url, { params });
    return response.data;
  },
  getMedicalSupplie: async (id) => {
    const url = "store/VTYT-store/by-id";
    const response = await axiosClient.get(url, {
      params: { id },
    });
    return response.data;
  },
  postImportForm: async (params) => {
    const url = "store/receipt/groups-VTYT";
    const response = await axiosClient.post(url, params);
    return response.data;
  },
  updateImportForm: async (params) => {
    const url = "store/receipt/groups-VTYT";
    const response = await axiosClient.put(url, params);
    return response.data;
  },
  getDetailReceipt: async (id) => {
    const url = "store/receipt/groups-VTYT/by-id";
    const response = await axiosClient.get(url, {
      params: { id },
    });
    return response.data;
  },
  getVTUnitConversion: async (vtytid) => {
    const url = "store/vt-unit-conversion/by-vat-tu-id";
    const response = await axiosClient.get(url, {
      params: { vtytid, limit: 1000 },
    });
    return response.data.data;
  },
  getQuyCach: async () => {
    const url = "store/quy_cach/list-quycach";
    const response = await axiosClient.get(url, {
      params: {
        limit: 1000,
      },
    });
    return response.data.data;
  },
  postQuyCach: async (params) => {
    const url = "store/quy_cach/create";
    const response = await axiosClient.post(url, params);
    return response.data;
  },
  putQuyCach: async (params) => {
    const url = "store/quy_cach/update";
    const response = await axiosClient.put(url, params);
    return response.data;
  },
  deleteQuyCach: async (id) => {
    const url = "store/quy_cach/delete";
    const response = await axiosClient.delete(url, { params: { id } });
    return response.data;
  },
  getListNguonVTYT: async () => {
    const url = "store/nguon_VTYT/list_nguon_VTYT";
    const response = await axiosClient.get(url, {
      params: {
        limit: 1000,
      },
    });
    return response.data.data;
  },
  postNguonVTYT: async (params) => {
    const url = "store/nguon_VTYT/create";
    const response = await axiosClient.post(url, params);
    return response.data;
  },
  putNguonVTYT: async (params) => {
    const url = "store/nguon_VTYT/update";
    const response = await axiosClient.put(url, params);
    return response.data;
  },
  deleteNguonVTYT: async (id) => {
    const url = "store/nguon_VTYT/delete";
    const response = await axiosClient.delete(url, { params: { id } });
    return response.data;
  },
  getListVTYTSearchKey: async (params) => {
    const url = "store/VTYT/searchKey";
    const response = await axiosClient.get(url, {
      params: {
        limit: params?.limit ?? 9999,
        ...params,
      },
    });
    return response.data;
  },

  getListVTYT: async (params) => {
    const url = "store/VTYT-store/list-DmVTYT";
    const response = await axiosClient.get(url, {
      params: params
    });
    return response.data;
  },
  postDanhMucVTYT: async (params) => {
    const url = "store/VTYT/create";
    const response = await axiosClient.post(url, params);
    return response.data;
  },
  putDanhMucVTYT: async (params) => {
    const url = "store/VTYT/update";
    const response = await axiosClient.put(url, params);
    return response.data;
  },
  deleteDanhMucVTYT: async (id) => {
    const url = "store/VTYT/delete";
    const response = await axiosClient.delete(url, { params: { id } });
    return response.data;
  },
  getListDonViAp: async (params) => {
    const url = "store/dau-thau/paging";
    const response = await axiosClient.get(url, {
      params: params,
    });
    return response.data.data;
  },
  getListBidDecision: async (page = 1, limit = 10) => {
    const url = "store/dau-thau/paging";
    const params = { page: page, limit: limit, type: 'VTYT' };
    const response = await axiosClient.get(url, { params: params });
    return response.data;
  },
  deleteBidDecision: async (id) => {
    const url = "store/dau-thau/delete";
    const params = { id: id };
    const response = await axiosClient.delete(url, { params: params });
    return response.data;
  },
  addBidDecision: async (params) => {
    const url = "store/dau-thau/create";
    const response = await axiosClient.post(url, params);
    return response.data;
  },
  editBidDecision: async (params) => {
    const url = "store/dau-thau/update";
    const response = await axiosClient.put(url, params);
    return response.data;
  },
  getListBidDecisionByVTYTParams: async (params) => {
    const url = "store/dau-thau-vtyt/findByVTYTId";
    const response = await axiosClient.get(url, { params: params });
    return response.data;
  },
  postDonViAp: async (params) => {
    const url = "store/don_vi_ap/create";
    const response = await axiosClient.post(url, params);
    return response.data;
  },
  putDonViAp: async (params) => {
    const url = "store/don_vi_ap/update";
    const response = await axiosClient.put(url, params);
    return response.data;
  },
  deleteDonViAp: async (id) => {
    const url = "store/don_vi_ap/delete";
    const response = await axiosClient.delete(url, { params: { id } });
    return response.data;
  },
  getDonViTinh: async () => {
    const url = "store/unit/list-unit";
    const response = await axiosClient.get(url, {
      params: {
        limit: 100,
      },
    });
    return response.data.data;
  },
  postDonViTinh: async (params) => {
    const url = "store/unit/create";
    const response = await axiosClient.post(url, params);
    return response.data;
  },
  putDonViTinh: async (params) => {
    const url = "store/unit/update";
    const response = await axiosClient.put(url, params);
    return response.data;
  },
  deleteDonViTinh: async (id) => {
    const url = "store/unit/delete";
    const response = await axiosClient.delete(url, { params: { id } });
    return response.data;
  },
  getThongKeVatTu: async (params) => {
    const url = "store/VTYT-store/thong_ke";
    const response = await axiosClient.get(url, { params });
    return response.data;
  },
  updateDetailLo: async (params) => {
    const url = "/store/VTYT-store/update";
    const res = await axiosClient.put(url, params);
    return res.data;
  },
  getListBoVTYT: async (params) => {
    const url = "store/bo-vtyt-thuoc/list";
    const response = await axiosClient.get(url, { params: params });
    return response.data;
  },
  getListBoVTYTTheoKho: async (params) => {
    const url = "store/receipt/bo-vtyt-thuoc-store";
    const response = await axiosClient.get(url, { params: params });
    return response.data;
  },
};

export default medicalSuppliesService;
